const dialog    = require ('../../../../../components/dialog/dialog')
const labelPreference = require('./purchase-label-preference');

export function start( detail ){ //console.log('dialog purchase detail', detail)

    // El framework enruta el click del radio; change no llega al grupo.
    if (detail.act === 'saveLabelSize') {
        labelPreference.saveLabelSize(detail.ev.target.value);
        return;
    }

	dialogBody[detail.id].start(detail) 
	
	detail.html =  dialogBody[detail.id]
	dialog.start(detail)


}


const dialogBody = {

	purchaseSellingPrice: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Update',
			class:'button primary',
	        dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},      

		start: function(detail){
			this.title     = 'WARNING'
			//this.des       = 'You want to save the data knowing that one of the selling prices of your item is less than the unit price'
			this.des         = 'Selling price on item is lower than purchased price. Do you want to save?'
			this.primary.dataDetail   = `data-detail='{
										"click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
									{"dest":"purchase", "elem":"fullcont",  "id":"purchase-fullcont", "act":"saveFromDialog", "entity":"purchase","save":"true"} ]}'`
			this.secondary.dataDetail   = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`					
		}

	},

	purchaseSellingPricePrint: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Update Print',
			class:'button primary',
	        dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},      

		start: function(detail){
			this.title     = 'WARNING'
			this.des       = 'You want to save the data knowing that one of the selling prices of your item is less than the unit price'
		
	        this.primary.dataDetail   = `data-detail='{
											"click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
										{"dest":"purchase", "elem":"fullcont", "id":"purchase-fullcont", "act":"saveFromDialog",
										"entity":"purchase","report":"purchase-invoice","type":"pdf","save":"true"  } ]}'`
			this.secondary.dataDetail   = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`					
		}

	},

	purchaseCreateSellingPrice: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Save',
			class:'button primary',
	        dataDetail:'',
		},

		secondary: {
			text:'Return',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},      

		start: function(detail){
			this.title     = 'WARNING'
			this.des       = 'You want to save the data knowing that one of the selling prices of your item is less than the unit price'
			this.primary.dataDetail   = `data-detail='{
	                       				 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"},
	                                     {"dest":"purchase", "elem":"fullcont",  "id":"purchase-fullcont", "act":"addOne", "entity":"purchase" } ]}'`
			this.secondary.dataDetail   = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`					
		}

	},

	purchaseprintlabel: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Print',
			class:'button primary',
	        dataDetail:'',
		},

		secondary: {
			text:'Cancel',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},      

		start: function(detail){
			this.title     				= 'Labels to print'
			this.des       				= ''
			this.primary.dataDetail     = `data-detail='{
	                       				  "click": [ {"dest":"ripple" }, 
	                                      {"dest":"purchase", "elem":"fullcont",  "id":"purchase-fullcont", "act":"labelgenerator", "entity":"purchase", "dbid":"${detail.dbid}"} ]}'`
			this.secondary.dataDetail   = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
			// Recupera el ultimo tamano elegido por este usuario.
            const labelSize = labelPreference.getLabelSize();
            this.bodyHtml = `
                ${detail.opcion}
				<br>
                <!-- row contiene los floats y c100 ocupa todo el ancho. -->
                <div class="row">
                <div class="radio radio-line c100" role="radiogroup" aria-labelledby="purchase-label-size-title">
                    <div>
                        <input type="radio" id="purchase-label-size-small" name="purchase-label-size" data-detail='{"click":[{"dest":"purchase","elem":"dialog","act":"saveLabelSize"}]}' value="default" ${labelSize === 'default' ? 'checked' : ''}>
                        <label for="purchase-label-size-small">4 in x 6 in</label>
                    </div>
                    <div>
                        <input type="radio" id="purchase-label-size-medium" name="purchase-label-size" data-detail='{"click":[{"dest":"purchase","elem":"dialog","act":"saveLabelSize"}]}' value="2.25x1.25" ${labelSize === '2.25x1.25' ? 'checked' : ''}>
                        <label for="purchase-label-size-medium">2.25 in x 1.25 in</label>
                    </div>
                    <div>
                        <input type="radio" id="purchase-label-size-large" name="purchase-label-size" data-detail='{"click":[{"dest":"purchase","elem":"dialog","act":"saveLabelSize"}]}' value="3x2" ${labelSize === '3x2' ? 'checked' : ''}>
                        <label for="purchase-label-size-large">3 in x 2 in</label>
                    </div>
                </div>
                </div>
            `

		}

	},

	purchaseItemQtySold: { 
		title:  '',
		des: '',
		bodyHtml:'',

		primary: {
			text:'Accept',
			class:'button primary',
	        dataDetail:'',
		},

		secondary: {
			text:'Cancel',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},    

		tertiary: {
			text:'',
			class:'button secondary  button-plain',
	        dataDetail:'',
		},      

		start: function(detail){
			this.title     = 'Info'
			//this.des       = 'You want to save the data knowing that one of the selling prices of your item is less than the unit price'
			this.des         = detail.info
			this.primary.dataDetail   = `data-detail='{
	                       				 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`
			this.secondary.dataDetail   = `data-detail='{
	                        			 "click": [ {"dest":"ripple" }, {"dest":"dialog", "act":"hide"} ]}'`					
		}

	},
}
